<p-floatlabel>
    <p-autocomplete #userAutocomplete
        [(ngModel)]="selectedUser"
        [suggestions]="users"
        [showClear]="true"
        [forceSelection]="true"
        styleClass="w-100"
        inputStyleClass="form-control"
        [minLength]="MinAutocompleteCharsToSearch"
        [disabled]="disabled"
        (completeMethod)="loadUsers($event)"
        (onSelect)="onChangeSelectedUser()"
        (onClear)="onChangeSelectedUser()"
        optionLabel="fullName"
        [emptyMessage]="l('::NoData')"
        inputId="label">
        <ng-template let-item pTemplate="item">
            <div>{{ item.fullName }}</div>
        </ng-template>
    </p-autocomplete>
    <label for="userAutocomplete">
        <app-label-content [isRequired]="isRequired">
            {{  l('::User') }}
        </app-label-content>
    </label>
</p-floatlabel>
